import { inject } from '@angular/core';
import { HttpInterceptorFn } from '@angular/common/http';
import { UserService } from '../services/user.service';

export const languageInterceptor: HttpInterceptorFn = (req, next) => {
  const lang = inject(UserService).selectedLang();

  req = req.clone({ setHeaders: { 'Accept-Language': lang } });

  return next(req);
};
